import { EmailVerificationRoutes } from '@/repository/auth';
const { SendVerificationEmail } = EmailVerificationRoutes;

export default {
	namespaced: true,
	actions: {
		async show({ }) {
			try {
				return await SendVerificationEmail();
			}
			catch (error) {
				console.error('Verification Email could not be sent.', error);
				throw error;
			}
		}
	}
}